export default {
    information: {
        content1Content:
            'We help customers in every industry improve their business. Create and send invoices all through the cloud without the restrictions of place and time.',
        content1Title: 'Manage Your Invoices - Anywhere, Anytime',
    },
    pageForm: {
        agreement: 'Please complete this required field.',
        businessType: {
            1: 'Organization',
            2: 'Self-employed',
        },
        createAccount: 'Create Account',
        employeeOptions: {
            1: '1 to 4 employees',
            2: '5 to 20 employees',
            3: '21 to 50 employees',
            4: '51 to 100 employees',
            5: '101 to 300 employees',
            6: '301 to 1000 employees',
            7: 'More than 1001 employees',
        },
        organizationHelper: 'Corporation, LLC, etc.',
        title: 'Create Your Free Account',
    },
};
